import store from '@/state/store'
import guestMiddleware from './../middleware/guestMiddleware';

export default [

  //#region Standard Dashboard Routes.
  //#region Auth Routes.
  {
    path: '/',
    name: 'default',
    redirect: store.getters['auth/loggedIn'] ? '/statistics' : '/login',
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
    beforeEnter: guestMiddleware
  },
  {
    path: '/account',
    name: 'account',
    meta: {
      middleware: ['authMiddleware'],
    },
    component: () => import('./views/account/account')
  },
  //#endregion
  
  //#region Errors Routes.
  {
    path: '*',
    redirect: '/404',
  },

  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  },
  {
    path: '/500',
    name: '500',
    component: require('./views/utility/500').default,
  },
  //#endregion
  
  //#region Admin Routes.
  {
    path: '/statistics',
    name: 'statistics',
    meta: {
      middleware: ['authMiddleware'],
    },
    component: () => import('./views/statistics/index')
  },
  {
    path: '/admins',
    name: 'admins.index',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_admin|add_admin|edit_admin|delete_admin'],
    },
    component: () => import('./views/admins/index')
  },
  {
    path: '/admins/:id/edit',
    name: 'admins.edit',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:edit_admin'],
    },
    component: () => import('./views/admins/edit')
  },
  {
    path: '/admins/password/:id/reset',
    name: 'admins.password.reset',
    meta: {
      middleware: ['authMiddleware'],
    },
    component: () => import('./views/admins/reset_password')
  },
  {
    path: '/admins/log_activity',
    name: 'admins log_activity',
    meta: {
        middleware: ['authMiddleware', 'canMiddleware:show_logs'],
    },
    component: () => import('./views/admins/log_activity')
  },
  //#endregion

  //#region Custom Dashboard Routes.

  //#region pank loans api Routes.
  {
    path: '/pankLoans/injouies',
    name: 'pankLoans.injouies',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_loan|show_details_loan'],
    },
    component: () => import('./views/pank_loans/injury/index')
  },
  {
    path: '/pankLoans/injouies/:id',
    name: 'pankLoans.injouies.details',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_details_loan'],
    },
    component: () => import('./views/pank_loans/injury/details')
  },
  //#endregion

  //#region pank loans api Routes.
  {
    path: '/pankLoans/martyrs',
    name: 'pankLoans.martyrs',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_loan|show_details_loan'],
    },
    component: () => import('./views/pank_loans/martyr/index')
  },
  {
    path: '/pankLoans/martyrs/:id',
    name: 'pankLoans.martyrs.details',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_details_loan'],
    },
    component: () => import('./views/pank_loans/martyr/details')
  },
  //#endregion

  //#region plots of lands api Routes.
  {
    path: '/plotsOfLand/injouies',
    name: 'plotsOfLand.injouies',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_land|show_details_land'],
    },
    component: () => import('./views/plots_of_land/injury/index')
  },
  {
    path: '/plotsOfLand/injouies/:id',
    name: 'plotsOfLand.injouies.details',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_details_land'],
    },
    component: () => import('./views/plots_of_land/injury/details')
  },
  //#endregion

  //#region plots of lands api Routes.
  {
    path: '/plotsOfLand/martyrs',
    name: 'plotsOfLand.martyrs',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_land|show_details_land'],
    },
    component: () => import('./views/plots_of_land/martyr/index')
  },
  {
    path: '/plotsOfLand/martyrs/:id',
    name: 'plotsOfLand.martyrs.details',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_details_land'],
    },
    component: () => import('./views/plots_of_land/martyr/details')
  },
  //#endregion

  //#region pilgrimage api Routes.
  {
    path: '/pilgrimage/sacrificers',
    name: 'pilgrimage.sacrificers',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_pilgrimage|show_details_pilgrimage'],
    },
    component: () => import('./views/pilgrimage/sacrificer/index')
  },
  {
    path: '/pilgrimage/sacrificers/:id',
    name: 'pilgrimage.sacrificers.details',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_details_pilgrimage'],
    },
    component: () => import('./views/pilgrimage/sacrificer/details')
  },
  //#endregion

  //#region booths api Routes.
  {
    path: '/booths',
    name: 'booths',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_booths'],
    },
    component: () => import('./views/booths/index')
  },
  {
    path: '/booths/:id',
    name: 'booths.details',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_details_booths'],
    },
    component: () => import('./views/booths/details')
  },
  //#endregion

  //#region scholar-ships api Routes.
  {
    path: '/scholar_ships/',
    name: 'scholar_ships',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_scholarships|show_details_scholarships'],
    },
    component: () => import('./views/scholar_ships/index')
  },
  {
    path: '/scholar_ships/:id',
    name: 'scholar_ships.details',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_details_scholarships'],
    },
    component: () => import('./views/scholar_ships/details')
  },
  //#endregion

  //#region housing units api Routes.
  {
    path: '/housing-units/martyrs',
    name: 'housingUnits.martyrs',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_housingunits|show_details_housingunits'],
    },
    component: () => import('./views/housing_units/martyr/index')
  },
  {
    path: '/housing-units/martyrs/:id',
    name: 'housingUnits.martyrs.details',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_details_housingunits'],
    },
    component: () => import('./views/housing_units/martyr/details')
  },

  {
    path: '/housing-units/injuries',
    name: 'housingUnits.injuries',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_housingunits|show_details_housingunits'],
    },
    component: () => import('./views/housing_units/injury/index')
  },
  {
    path: '/housing-units/injuries/:id',
    name: 'housingUnits.injuries.details',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_details_housingunits'],
    },
    component: () => import('./views/housing_units/injury/details')
  },

  {
    path: '/housing-units/employees',
    name: 'housingUnits.employees',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_housingunits|show_details_housingunits'],
    },
    component: () => import('./views/housing_units/employee/index')
  },
  {
    path: '/housing-units/employees/:id',
    name: 'housingUnits.employees.details',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_details_housingunits'],
    },
    component: () => import('./views/housing_units/employee/details')
  },
  //#endregion
  
  //#region plots of land api Routes.
  {
    path: '/plots-of-land-2/martyrs',
    name: 'plotsOfLand2.martyrs',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_plotsofland|show_details_plotsofland'],
    },
    component: () => import('./views/plots_of_land_2/martyr/index')
  },
  {
    path: '/plots-of-land-2/martyrs/:id',
    name: 'plotsOfLand2.martyrs.details',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_details_plotsofland'],
    },
    component: () => import('./views/plots_of_land_2/martyr/details')
  },

  {
    path: '/plots-of-land-2/injuries',
    name: 'plotsOfLand2.injuries',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_plotsofland|show_details_plotsofland'],
    },
    component: () => import('./views/plots_of_land_2/injury/index')
  },
  {
    path: '/plots-of-land-2/injuries/:id',
    name: 'plotsOfLand2.injuries.details',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_details_plotsofland'],
    },
    component: () => import('./views/plots_of_land_2/injury/details')
  },

  {
    path: '/plots-of-land-2/employees',
    name: 'plotsOfLand2.employees',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_plotsofland|show_details_plotsofland'],
    },
    component: () => import('./views/plots_of_land_2/employee/index')
  },
  {
    path: '/plots-of-land-2/employees/:id',
    name: 'plotsOfLand2.employees.details',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_details_plotsofland'],
    },
    component: () => import('./views/plots_of_land_2/employee/details')
  },
  //#endregion
  
  //#region government loans api Routes.
  {
    path: '/government-loans/martyrs',
    name: 'governmentLoans.martyrs',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_governmentloans|show_details_governmentloans'],
    },
    component: () => import('./views/government_loans/martyr/index')
  },
  {
    path: '/government-loans/martyrs/:id',
    name: 'governmentLoans.martyrs.details',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_details_governmentloans'],
    },
    component: () => import('./views/government_loans/martyr/details')
  },

  {
    path: '/government-loans/injuries',
    name: 'governmentLoans.injuries',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_governmentloans|show_details_governmentloans'],
    },
    component: () => import('./views/government_loans/injury/index')
  },
  {
    path: '/government-loans/injuries/:id',
    name: 'governmentLoans.injuries.details',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_details_governmentloans'],
    },
    component: () => import('./views/government_loans/injury/details')
  },

  {
    path: '/government-loans/employees',
    name: 'governmentLoans.employees',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_governmentloans|show_details_governmentloans'],
    },
    component: () => import('./views/government_loans/employee/index')
  },
  {
    path: '/government-loans/employees/:id',
    name: 'governmentLoans.employees.details',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_details_governmentloans'],
    },
    component: () => import('./views/government_loans/employee/details')
  },
  //#endregion
  
   //#region health card api Routes.
   {
    path: '/health-card/martyrs',
    name: 'healthCard.martyrs',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_healthcard|show_details_healthcard'],
    },
    component: () => import('./views/health_card/martyr/index')
  },
  {
    path: '/health-card/martyrs/:id',
    name: 'healthCard.martyrs.details',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_details_healthcard'],
    },
    component: () => import('./views/health_card/martyr/details')
  },
  //#endregion

  //#region pilgrimage api Routes.
  {
    path: '/exportData',
    name: 'exportData',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:export_to_excel_loan|export_to_excel_land|export_to_excel_pilgrimage|export_to_excel_scholarships|export_to_excel_housingunits|export_to_excel_governmentloans|export_to_excel_booths'],
    },
    component: () => import('./views/export_data/index')
  },
  //#endregion

  //#region print_id api Routes.
  {
    path: '/print_id/',
    name: 'print_id',
    meta: {
      middleware: ['authMiddleware', 'canMiddleware:show_beneficiary|print_beneficiary_card'],
    },
    component: () => import('./views/print_id/index')
  },
  //#endregion

  //#endregion
]
